import { render, staticRenderFns } from "./EWRCard.vue?vue&type=template&id=8dc547b6"
import script from "./EWRCard.vue?vue&type=script&lang=js"
export * from "./EWRCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports